/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {

};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.EndInterviewAction.REQUEST_ENDINTERVIEW:
      return {
        ...state,
    };
    case actions.EndInterviewAction.ENDINTERVIEW_RECEIVED:
          return{
      ...state,
    };


    default:
      return state;
  }
};

export default reducer;
